(() => {
  document.querySelectorAll('.product-qa').forEach((qa) => {
    const toggleBtn = qa.querySelector('.product-qa__ask-toggle');
    const formWrap = qa.querySelector('.product-qa__form-wrap');
    const form = qa.querySelector('.product-qa__form');
    const successMsg = qa.querySelector('.product-qa__form-success');

    if (!toggleBtn || !formWrap) return;

    toggleBtn.addEventListener('click', () => {
      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      formWrap.hidden = expanded;
      if (!expanded) {
        formWrap.querySelector('input, textarea')?.focus();
      }
    });

    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('.product-qa__submit');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird gesendet…';

      try {
        const data = new FormData(form);
        const resp = await fetch('/contact#ContactFormQA', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: data,
        });

        if (resp.ok) {
          form.hidden = true;
          if (successMsg) successMsg.hidden = false;
          toggleBtn.setAttribute('aria-expanded', 'true');
        } else {
          throw new Error('Server error');
        }
      } catch {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Frage absenden';
        submitBtn.insertAdjacentHTML(
          'afterend',
          '<p class="product-qa__error" style="color:red;font-size:1.3rem;margin-top:.6rem;">Fehler beim Senden. Bitte versuche es erneut.</p>'
        );
        setTimeout(() => qa.querySelector('.product-qa__error')?.remove(), 5000);
      }
    });
  });
})();
